import { render, staticRenderFns } from "./DemoRequestList.vue?vue&type=template&id=089685c1"
import script from "./DemoRequestList.vue?vue&type=script&lang=js"
export * from "./DemoRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports